export default {
  lstTab: {
    indicators: 'Chỉ Tiêu',
    deceptiveOrder: 'Tín hiệu Nhiễu',
    priceVolume: 'Phân Tích Giá-KL',
  },

  deceptiveTab: {
    overview: 'TỔNG QUAN',
    abnormaly: 'MUA TRẦN/BÁN SÀN',
    cancelled: 'HỦY LỆNH',
    pressing: 'ĐÈ GIÁ',
    aggressive: 'MUA/BÁN CHỦ ĐỘNG',
    closing: 'CHỐT PHIÊN',
  },

  overviewHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    VOLUME: 'KHỐI LƯỢNG',
    CE_FL: 'MUA TRẦN/BÁN SÀN',
    CANCELED: 'HỦY LỆNH',
    PRESSING: 'ĐÈ GIÁ',
    AGGRESSIVE: 'MUA BÁN CHỦ ĐỘNG',
    CLOSING: 'CHỐT PHIÊN',
  },

  overviewContent: {
    ceflTooltip:
      'Mã cổ phiếu quá mua tại mức giá trần hoặc quá bán tại mức giá sàn',
    cancelledTooltip: 'Mã cổ phiếu được mua sau đó bị hủy lệnh',
    pressingTooltip:
      'Cổ phiếu được mua với khối lượng lớn nhằm gây ảnh hưởng tới mức giá',
    aggressiveTooltip: 'Cổ phiếu được giao dịch nhanh chóng để chốt lợi nhuận',
    closingTooltip:
      'Cổ phiếu được mua và bán tại thời điểm chốt phiên của thị trường',
  },

  ceflAbnormalityHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOLUME: 'K.L',
    AVG_VOLUME: 'K.L<br>(T.B 10D)</br>',
    VOLUME_CE_FL_UNMATCHED: 'K.L<br>(CHƯA KHỚP MUA TRẦN/BÁN SÀN)</br>',
    RATIO: 'TỶ LỆ',
    SESSION: 'PHIÊN',
    PREV_SESSION: 'PHIÊN<br>(TRƯỚC)</br>',
    RANK: 'THỨ HẠNG',
  },

  cancelledHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOLUME: 'KHỐI LƯỢNG',
    NR_CO: 'SỐ LỆNH HỦY',
    VOL_CO: 'K.L LỆNH HỦY',
    NR_CO_BUY: 'SỐ LỆNH HỦY<br>(MUA)</br>',
    VOL_CO_BUY: 'K.L LỆNH HỦY<br>(MUA)</br>',
    NR_CO_SELL: 'SỐ LỆNH HỦY<br>(BÁN)</br>',
    VOL_SELL: 'K.L LỆNH HỦY<br>(BÁN)</br>',
  },

  aggressiveHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOLUME: 'K.L',
    VOLUME_BU_SD: 'K.L<br>(BU/SD)',
    AVG_VOLUME: 'K.L TRUNG BÌNH<br>(10D)</br>',
    TOTAL_VOLUME_BU: 'TỔNG K.L<br> mua chủ động',
    TOTAL_VOLUME_SD: 'TỔNG K.L<br> bán chủ động',
    RANK: 'THỨ HẠNG',
  },

  aggressiveContent: {
    tooltipContent: 'Cổ phiếu có sự bất cân bằng trong cung và cầu',
    line_1: 'Lệnh Chủ Động',
    line_2: 'K.L Trung Bình 10D',
    line_3: 'Tỷ lệ K.L mua chủ động/bán chủ động',
    line_4: {
      part_1: 'Điều kiện: Cổ phiếu với ',
      part_2: 'khối lượng trung bình 10 ngày > ',
      part_3: ' và ',
      part_4: 'tổng khối lượng mua chủ động/bán chủ động ',
      part_5: ' lần',
    },
    totalVol: 'Tổng khối lượng:',
    bu: 'Mua chủ động (BU) = ',
    sd: 'Bán chủ động (SD) = ',
  },

  abnormalityContent: {
    tooltipContent: 'Cổ phiếu quá mua tại giá trần hoặc quá bán tại giá sàn',
    line_1: 'Mua Trần/ Bán Sàn',
    line_2: 'Loại Bất Thường',
    line_3: 'K.L Trung Bình 10D',
    line_4: {
      part_1: 'Tỷ lệ K.L Chưa Khớp Mua Trần/Bán Sàn ',
      part_2: '(K.L T.B 10D)',
    },
    line_5: {
      part_1: 'Điều kiện: Cổ phiếu ',
      part_2: ' với ',
      part_3: ' khối lượng > ',
      part_4: ' và ',
      part_5: 'tỷ lệ khối lượng chưa khớp Mua trần/Bán sàn > ',
    },
    filter_quote_1: 'mua tại giá trần',
    filter_quote_2: 'bán tại giá sàn',
  },

  cancelledContent: {
    tooltipContent: 'Khối lượng lớn cổ phiếu bị hủy lệnh giao dịch',
    line_1: 'Hủy Lệnh',
    line_2: 'Khối lượng 10D',
    line_3: {
      part_1: 'Điều kiện: Cổ phiếu với ',
      part_2: 'khối lượng trung bình > ',
      part_3: ' và có tín hiệu của ',
      part_4: 'hủy lệnh',
    },
  },

  pressingHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    AVG_VOLUME_10D: 'K.L T.B 10D',
    PRESSING_VOL_BUY: 'K.L ĐÈ GIÁ <br>(MUA)</br>',
    BID: 'Giá Mua',
    PRESSING_VOL_SELL: 'K.L ĐÈ GIÁ <br>(BÁN)</br>',
    ASK: 'Giá Bán',
    RANK: 'THỨ HẠNG',
  },

  pressingContent: {
    tooltipContent:
      'Nhà giao dịch đặt một lượng lớn cổ phiếu mà không khớp giá',
    line_1: 'Đè Giá',
    line_2: 'K.L Trung Bình 10D',
    line_3: 'Lệnh Đè',
    line_4: 'Tỷ lệ',
    line_5: {
      part_1: 'Điều kiện: Cổ phiếu với ',
      part_2: 'khối lượng trung bình 10D > ',
      part_3: ' và có dấu hiệu của ',
    },
    filter_1: 'đè lệnh mua > ',
    filter_2: 'đè lệnh bán > ',
    fitler_3: 'đè lệnh mua và lệnh bán> ',
  },

  closingHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOLUME: 'K.L',
    VOLUME_AFTER_2PM: 'K.L<br>(SAU 2PM)</br>',
    VOLUME_BEFORE_2PM: 'K.L<br>(8AM - 2PM)</br>',
    AVG_VOLUME_10D: 'K.L T.B<br>(10D)</br>',
    VOLUME_PREVIOUS: 'K.L<br>(TRƯỚC)</br>',
    RANK: 'THỨ HẠNG',
  },

  closingContent: {
    tooltipContent: 'Cổ phiếu được giao dịch chủ động từ 2:00 PM (GMT+7)',
    line_1: 'Lệnh Chốt Phiên',
    line_2: 'K.L Trung bình 10D',
    line_3: {
      part_1: 'Tỷ lệ vượt',
      part_2: '(SO VỚI PHIÊN TRƯỚC)',
    },
    line_4: {
      part_1: 'Điều kiện: Cổ phiếu với ',
      part_2: 'khối lượng trung bình 10 ngày> ',
      part_3: ' và ',
      part_4: ' tỷ lệ vượt cao hơn ',
      part_5: '%',
      part_6: ' so với trước đó',
    },
  },

  filterAbnormalityType: {
    ceilingBuy: 'Mua Trần',
    floorSell: 'Bán Sàn',
  },

  filterAvgVolume: {
    1: '>10,000',
    2: '>50,000',
    3: '>100,000',
    4: '>300,000',
    5: '>500,000',
  },

  filterAvgVolumePressing: {
    1: '>10,000',
    2: '>20,000',
    3: '>30,000',
    4: '>40,000',
    5: '>50,000',
  },

  filterAvgVolumeClosing: {
    1: '>100,000',
    2: '>200,000',
    3: '>300,000',
    4: '>400,000',
    5: '>500,000',
  },

  filterExceedPercent: {
    1: '20%',
    2: '40%',
    3: '60%',
    4: '80%',
    5: '100%',
  },

  filterRate: {
    1: '>0.5',
    2: '>0.8',
    3: '>1',
    4: '>1.2',
    5: '>1.5',
  },

  filterOrderType: {
    more: 'Lớn hơn',
    less: 'Nhỏ hơn',
  },

  filterPressingOrderType: {
    1: 'Mua',
    2: 'Bán',
    3: 'Cả hai',
  },

  filterProportion: {
    1: '>10%',
    2: '>30%',
    3: '>50%',
    4: '>70%',
  },

  filterVolumeBU_SD: {
    1: '0.3',
    2: '0.6',
    3: '1.0',
    4: '1.5',
    5: '2.0',
  },

  opverviewWatchlist: {
    watchList1: 'Danh sách theo dõi 1',
    watchList2: 'Danh sách theo dõi 2',
  },

  deceptiveDataMessage: {
    noDataForFilter: 'Không có cổ phiếu thỏa mãn điều kiện.',
    nodataClosing: 'Dữ liệu chỉ có từ sau 2PM',
  },

  methodology: 'PHƯƠNG PHÁP',
  listOfFeature: {
    VolPriceIncrease: 'Khối lượng Tăng và Giá Tăng',
    VolIncPriceDecr: 'Khối lượng Tăng và Giá Giảm',
    PriceIncrease: 'Giá tăng liên tục trong nhiều phiên',
    PriceDecr: 'Giá giảm liên tục trong nhiều phiên',
    VolIncrease: 'Khối lượng tăng liên tục trong nhiều phiên',
  },
  tootipNameOfFeature:
    'Khối lượng ước tính được tính toán trên mỗi phiên bởi FiinTrade',
  priceVolumeHeader: {
    ticker: 'MÃ',
    price: 'GIÁ',
    percentPriceChange: '"% THAY ĐỔI',
    volume: 'K.L',
    volume_expected: 'K.L<br>(KỲ VỌNG)</br>',
    nrOfDay: 'SỐ NGÀY',
    lastClose: 'GIÁ BAN ĐẦU',
    lastVol: 'K.L BAN ĐẦU',
    RSI: 'RSI14',
    ranking: 'THỨ HẠNG',
  },
  indicatorType: {
    MovingAvg: 'T.B Động',
    Indicators: 'Chỉ tiêu',
    Summary: 'Tổng hợp',
  },
};
